define("shared/utils/array-filters/extract-values", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.extractValues = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * Extracts a list of values, for a given key, from a list of of objects.
   *
   * @param data Array of objects
   * @param keyName Name of the key to extract from each object in `data`
   *
   * @returns Array of extracted values for the given `keyName`
   */
  const extractValues = (data, keyName) => {
    if (!keyName || !data.length) {
      return [];
    }

    return data.map(item => item[keyName]);
  };

  _exports.extractValues = extractValues;
  var _default = extractValues;
  _exports.default = _default;
});